module.exports = __webpack_public_path__ + "static/media/profits.59c11f32.svg";